import Map from "./Map"

export default  Map;



// WEBPACK FOOTER //
// ./src/common/components/Map/index.js